
const { BASE_URL } = require("./client");

const ENROLLED_USER = BASE_URL + "/api/enrolledusers";
const ENROLLED_USER_ACCESS = BASE_URL + "/api/enrolleduser/give/access/";
const PROGRAM_CERTIFICATE_UPLOAD = BASE_URL + '/api/program/certificate/upload/';
const WORKEX_CERTIFICATE_UPLOAD = BASE_URL + '/api/workex/certificate/upload/';

export { ENROLLED_USER , PROGRAM_CERTIFICATE_UPLOAD , WORKEX_CERTIFICATE_UPLOAD , ENROLLED_USER_ACCESS};